import * as actionTypes from '../actions/actionTypes';

import updateObject from '../../util/updateObject';

const initialState = {
    loading: false, 
    error: null, 
    questions: null
};

const changePasswordStart = (state, action) => {
    return updateObject(state, { loading: true, error: null });
};

const changePasswordSuccess = (state, action) => {
    return updateObject(state, { loading: false });
};

const changePasswordFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error });
};

const securityQuestionsLoadStart = (state, action) => {
    return updateObject(state, { loading: true, error: null });
}

const securityQuestionsLoadSuccess = (state, action) => {
    return updateObject(state, { loading: false, questions: action.questions });
};

const securityQuestionsLoadFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error });
};

const securityQuestionsSetStart = (state, action) => {
    return updateObject(state, { loading: true, error: null });
};

const securityQuestionsSetSuccess = (state, action) => {
    return updateObject(state, { loading: false });
};

const securityQuestionsSetFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error });
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.CHANGE_PASSWORD_START: return changePasswordStart(state, action);
        case actionTypes.CHANGE_PASSWORD_SUCCESS: return changePasswordSuccess(state, action);
        case actionTypes.CHANGE_PASSWORD_FAIL: return changePasswordFail(state, action);
        case actionTypes.SECURITY_QUESTIONS_LOAD_START: return securityQuestionsLoadStart(state, action);
        case actionTypes.SECURITY_QUESTIONS_LOAD_SUCCESS: return securityQuestionsLoadSuccess(state, action);
        case actionTypes.SECURITY_QUESTIONS_LOAD_FAIL: return securityQuestionsLoadFail(state, action);
        case actionTypes.SECURITY_QUESTIONS_CHANGE_START: return securityQuestionsSetStart(state, action);
        case actionTypes.SECURITY_QUESTIONS_CHANGE_SUCCESS: return securityQuestionsSetSuccess(state, action);
        case actionTypes.SECURITY_QUESTIONS_CHANGE_FAIL: return securityQuestionsSetFail(state, action);
        default: return state;
    }
}

export default reducer;